import {Component, OnInit, ViewChild} from '@angular/core';

import {AlertService, AuthenticationService, ClientProfileService, ProjectService} from '../../_services';

import {ActivatedRoute, Router} from '@angular/router';

import {PoamItem, Project, User} from '../../_models';
import {LoginHelper} from '../../helpers';
import {IndexConfigService} from "../../_services/index.config.service";
import {ActionPlan} from "../../_models/actionPlan";
import {FormBuilder, Validators} from "@angular/forms";
import {SelectProjectControlItemComponent} from "../selectProjectControlItem/select-project-control-item.component";
import {
  SelectSingleProjectControlItemComponent
} from "../selectSingleProjectControlItem/select-single-project-control-item.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { DictionaryService } from "../../_services/dictionary.service";
import { AppTextResourcesService } from '../../_services/app.text.resources.service';
import {InspectionResultsPopupComponent} from "../inspectionResultsPopup/inspectionResultsPopup.component";
import {DialogService} from "primeng/dynamicdialog";

@Component({
    standalone: false,
  selector: "poam-list-component",
  templateUrl: './global-device-list.component.html',
  styleUrls: ['./global-device-list.component.scss'],
})

export class GlobalDeviceListComponent implements OnInit {
  devices: any[] = [];
  currentUser: User;
  tenantName: string;
  cols: any[] = [
    {'field': 'projectName', 'header': 'Project'},
    {'field': 'topic', 'header': 'Topic'},
    {'field': 'name', 'header': 'Name'},
    {'field': 'riskLevel', 'header': 'Risk'},
    {'field': 'responsibleParty', 'header': 'Owner'},
    {'field': 'currentStatusValue', 'header': 'Status'},
    {'field': 'dueDate', 'header': 'Due Date'},
  ]
  lowMediumHigh = {0: 'Low', 1: 'Medium', 2: 'High'};

  constructor(
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public formBuilder: FormBuilder,
    public alertService: AlertService,
    public config: IndexConfigService,
    public authenticationService: AuthenticationService,
    public dictionaryService: DictionaryService,
    public dialog: MatDialog,
    public dialogService: DialogService,
    public clientProfileService: ClientProfileService,
    private constants: AppTextResourcesService) {

  }

  ngOnInit() {

    const tenantName = this.tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.clientProfileService.getGlobalDevices().subscribe(d => this.devices = d);
  }

  openFindings(result) {
    this.dialogService.open(InspectionResultsPopupComponent,
      {
        width: '50%',
        contentStyle: {overflow: 'auto'},
        baseZIndex: 10010,
        maximizable: true,
        data: {
          results: result.inspectionResults,
          allowDismiss: true
        }
      });
  }
}
